export function usernameToColor(string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }

  return color;
}

export function getInitials(fullname) {
  const [name, lastName] = fullname.split(' ');

  if (name && lastName) {
    return `${name.charAt(0)}${lastName.charAt(0)}`;
  }

  return fullname.charAt(0).toUpperCase();
}
